<template>
  <b-modal
    id="modal-department-role-mapping"
    title="Gán role vào phòng ban"
    size="md"
    centered
    hide-footer
    @hide="reset"
  >
    <b-overlay :show="loading">
      <div v-if="department">
        <p class="font-weight-bold mb-3">{{ department.name }}</p>
        <div v-if="department.roles && department.roles.length" class="mb-4">
          <p class="text-muted mb-2">Role đã gán:</p>
          <div class="d-flex flex-wrap gap-2">
            <b-badge
              v-for="role in department.roles"
              :key="role.id"
              variant="primary"
              class="d-flex align-items-center p-2 mr-2 mb-2"
              style="font-size: 13px"
            >
              {{ role.roleName }}
              <span
                class="ml-2 cursor-pointer"
                style="cursor:pointer"
                @click="removeRole(role)"
              >
                &times;
              </span>
            </b-badge>
          </div>
        </div>
        <div v-else class="text-muted mb-4">Chưa có role nào được gán.</div>
        <hr />
        <p class="text-muted mb-2">Gán role mới:</p>
        <b-row>
          <b-col>
            <basic-select
              label="Chọn role"
              name="roleId"
              placeholder="-- Chọn role --"
              :value.sync="selectedRoleId"
              :options="availableRoles"
              value-field="id"
              text-field="name"
            />
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end mt-2">
          <b-button class="btn mr-4" type="button" @click="cancel">
            Đóng
          </b-button>
          <b-button
            class="btn btn-success"
            :disabled="!selectedRoleId"
            @click="assignRole"
          >
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
            </span>
            Gán role
          </b-button>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>
<script>
export default {
  name: 'DepartmentRoleMapping',
  props: {
    department: {
      type: Object,
      default: null,
    },
    allRoles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      selectedRoleId: null,
    };
  },
  computed: {
    assignedRoleIds() {
      if (!this.department || !this.department.roles) return [];
      return this.department.roles.map((r) => r.roleId);
    },
    availableRoles() {
      return this.allRoles.filter(
        (r) => !this.assignedRoleIds.includes(r.id),
      );
    },
  },
  methods: {
    async assignRole() {
      if (!this.selectedRoleId || !this.department) return;
      try {
        this.loading = true;
        const { meta, error } = await this.$api.post(
          `/Department/${this.department.id}/role-assignments`,
          { roleId: this.selectedRoleId },
        );
        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
            preventDuplicates: true,
          });
        }
        this.$toastr.s({ title: 'Thành công !', msg: 'Gán role thành công' });
        this.selectedRoleId = null;
        this.$emit('mapping-changed');
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
          preventDuplicates: true,
        });
      } finally {
        this.loading = false;
      }
    },
    async removeRole(role) {
      if (!this.department) return;
      try {
        this.loading = true;
        const { meta, error } = await this.$api.delete(
          `/Department/${this.department.id}/role-assignments/${role.roleId}`,
        );
        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
            preventDuplicates: true,
          });
        }
        this.$toastr.s({ title: 'Thành công !', msg: 'Gỡ role thành công' });
        this.$emit('mapping-changed');
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
          preventDuplicates: true,
        });
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      this.$bvModal.hide('modal-department-role-mapping');
    },
    reset() {
      this.selectedRoleId = null;
    },
  },
};
</script>
